/** @format */

import process from "process";

const apiURL = process.env.REACT_APP_API_URL;
//const token = localStorage.getItem("idToken");
//localStorage.getItem("idToken"),
export async function attachZip(
  instanceId,
  docId,
  modelId,
  files,
  token,
  fileExtension,
  role,
  json = null
) {
  try {
    const createDocsResponse = await attachementDoc(
      instanceId,
      docId,
      token,
      modelId,
      fileExtension,
      role
    );
    if (createDocsResponse.statusCode === 200) {
      const presignedUrl = createDocsResponse.message.PresignedURL;
      await uploadDoc(files, presignedUrl).then((response) => {
     
        return response;
      });
    }
  } catch (error) {
    throw new Error(error);
  }
}

async function attachementDoc(
  instanceId,
  docId,
  token,
  modelId,
  fileExtension,
  role
) {
  try {
    const route = role === "superadmin" ? "/admin/document/attachment/upload" : "/document/attachment/upload";
    const response = await fetch(apiURL + "/document/attachment/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        DocumentId: docId,
        InstanceId: instanceId,
        ModelId: modelId,
        AttachmentType: fileExtension,
      }),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();

    return data;
  } catch (error) {
    throw new Error(error);
  }
}

async function uploadDoc(file, signedUrl) {
  var mypresignedurl = signedUrl;
  var requestOptions = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": "application/pdf",
      "Content-Length": file.length,
    },
  };

  try {
    const response = await fetch(mypresignedurl, requestOptions);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.statusCode}`);
    }
  } catch (error) {
    throw new Error(error);
  }
}
